import { FormattedRpServiceConfigurationAttribute } from "@idw-types/data/rp-service-configuration";
import { SelectOption } from "@iddataweb/idw-common-ui/types";
import { AXNUIRadioGroupInput } from "@iddataweb/idw-common-ui/containers";
import commonStyles from "@styles/common.less";
import { AXNUIThemingLabelComponent } from "@containers/common/axnui-theming-preview-container/axnui-theming-label-component/axnui-theming-label-component";
import { useMemo } from "react";

type AXNUIThemingRadioInputComponentProps = {
    attribute: FormattedRpServiceConfigurationAttribute;
    isRequired: boolean;
    label: string;
    options?: Array<SelectOption & { label2?: string; }>;
};

export const AXNUIThemingRadioInputComponent = (props: AXNUIThemingRadioInputComponentProps) => {
    const { attribute, isRequired, label, options = [] } = props;

    const fakeValue = useMemo(() => {
        return options?.length > 0 ? options[0].value : null;
    }, []);

    return (
        <div className={commonStyles.axnuiPreviewInputContainer}>
            <AXNUIThemingLabelComponent
                controlId={`attribute-input-${attribute.attributeType.id}`}
                label={label}
                isRequired={isRequired}
            />
            <AXNUIRadioGroupInput
                value={fakeValue}
                idPrefix={attribute.name}
                preferences={options}
                isSubmitting={false}
                isPlaceholder={false}
                isDisabled={false}
                readOnly={true}
                onChange={() => { }}
            />
        </div>
    );
};
